import {
  ExpertReportType,
  TvictimExpertise,
} from 'containers/common/LegalProceedings/ExpertReport/typings';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { get, isEmpty } from 'lodash';

export const showAlert = (
  judgementAddDocument: JudgementADDDocumentType,
  expertReport?: ExpertReportType,
  judgementOnMerits?: any,
) => {
  const victimExpertise =
    get(expertReport, 'victimExpertises', []).find((item: TvictimExpertise) =>
      get(judgementAddDocument, 'expertises', []).find(
        (el: any) =>
          item?.expertiseJudgementAddDocumentId ===
          get(el, 'expertiseJudgementAddDocumentId', ''),
      ),
    ) || {};

  const vehicleExpertise =
    get(expertReport, 'vehiculeExpertises', []).find(item =>
      get(judgementAddDocument, 'expertises', []).find(
        (el: any) =>
          item?.expertiseJudgementAddDocumentId ===
          get(el, 'expertiseJudgementAddDocumentId', ''),
      ),
    ) || {};

  const jom =
    get(judgementOnMerits, 'judgementOnMerits', []).find((jom: any) => {
      return get(jom, 'jom.civjs', []).some((item: any) => {
        const civjacce = get(item, 'civjacce', []).some((civjacc: any) =>
          get(judgementAddDocument, 'expertises', []).find((el: any) => {
            return (
              civjacc?.expertiseJudgementAddDocumentId ===
              get(el, 'expertiseJudgementAddDocumentId', '')
            );
          }),
        );
        const civjmece = get(item, 'civjmece', []).some((civjmec: any) =>
          get(judgementAddDocument, 'expertises', []).find((el: any) => {
            return (
              civjmec?.expertiseJudgementAddDocumentId ===
              get(el, 'expertiseJudgementAddDocumentId', '')
            );
          }),
        );
        const civjmede = get(item, 'civjmede', []).some((civjmede: any) =>
          get(judgementAddDocument, 'expertises', []).find((el: any) => {
            return (
              civjmede?.expertiseJudgementAddDocumentId ===
              get(el, 'expertiseJudgementAddDocumentId', '')
            );
          }),
        );
        return civjacce || civjmece || civjmede;
      });
    }) || {};

  return {
    hasExpertise: !isEmpty(victimExpertise) || !isEmpty(vehicleExpertise),
    hasJom: !isEmpty(jom),
  };
};
